<template lang="html">
  <modal-template
    ref="modal"
    modal-size="sm"
    title="Opções de variações"
    type-modal="add_variation_type_option_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="save()">

        <d-form-row>
          <d-col md="12" class="form-group">
            <label for="feName">Nome</label>
            <d-form-input type="text" v-model="model.name" id="feName" placeholder="Nome" />
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="cancel()"
        class="btn btn-sm btn-secondary mr-4"
      >Cancelar</d-button>
      <d-button
        type="button"
        @click="save()"
        class="btn btn-sm btn-primary"
      >Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ModalTemplate from '_shared/Modal.vue';
import ProductService from '_services/rest/modules/product';
import { _LOAD_TYPE_OPTION_MODEL_, MODEL_TYPE_OPTION, _RELOAD_VARIATION_ } from '../ProductModel';

export default {
  name: 'add-variation-type-option',
  components: {
    ModalTemplate,
  },
  props: {},
  data() {
    return {
      loading: false,
      type: null,
      model: MODEL_TYPE_OPTION,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    cancel() {
      this.setToggle({ type: 'add_variation_type_option_modal', bool: false });
    },
    createOption() {
      const { product } = this.$store.state.product;
      ProductService.saveNewVariationTypeOption(this.model, product.id, this.type.id)
        .then(() => {
          this.success();
        })
        .catch(error => this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' }))
        .finally(() => this.toggleLoading());
    },
    save() {
      this.toggleLoading();
      if (this.model.id) {
        return this.updateOption();
      }
      return this.createOption();
    },
    success() {
      Events.$emit(_RELOAD_VARIATION_);
      this.setToggle({ type: 'add_variation_type_option_modal', bool: false });
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
    updateOption() {
      ProductService.saveVariationTypeOption(this.model)
        .then(() => {
          this.success();
        })
        .catch(error => this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' }))
        .finally(() => this.toggleLoading());
    },
  },
  mounted() {
    Events.$on(_LOAD_TYPE_OPTION_MODEL_, ({ type, option }) => {
      this.type = type;
      this.model = { ...option };
    });
  },
};
</script>

<style lang="scss" scoped>

</style>
